<template>
    <div
        data-cy="ess-controls"
        :class="[
            isExternalControlEssSelected
                ? 'device-controls__block ess-external-control'
                : 'device-controls__block',
            { 'dci__order-1': essAction != null },
        ]"
    >
        <div class="device-controls__row device-controls__row--title">
            <span class="dci__title">
                <span class="sg-vrm-icon_111_ess-24px"></span>
                {{ formattedName }}
            </span>
            <div v-if="isWaitingForResponse" class="dci__status">
                <spinner />
                {{ $t('dashboard.dci.loading') }}
            </div>
        </div>
        <!-- ESS state warning , not adding additional height if externalControlEssSelected due to it having no SOC div-->
        <div
            v-if="changeModeTimer.nextChange !== null"
            :style="!isExternalControlEssSelected && { height: topHeight + 'px' }"
            class="device-controls__body device-controls__body--ess"
        >
            <change-warning
                @cancel="
                    changeModeTimer.clearChangeTimer();
                    selectedValue = essStateMode;
                "
                @confirm="changeModeTimer.confirmChange()"
            >
                <div
                    v-html="
                        $t('dashboard.dci.countdown_timer', {
                            seconds: timerLimit - changeModeTimer.changeSeconds,
                            nextState: $t(
                                `dashboard.dci.ess.radio.state_${changeModeTimer.nextChange}`,
                            ),
                        })
                    "
                ></div>
            </change-warning>
        </div>
        <div
            v-if="changeModeTimer.nextChange === null && !onlySlider"
            ref="essTop"
            class="device-controls__body device-controls__body--ess"
        >
            <span v-if="batteryLifeStateChange.error" class="dci__warning dci__warning--inline">
                {{
                    $t('dashboard.dci.errors.' + batteryLifeStateChange.error, {
                        i18nFallback: dciErrorFallback(batteryLifeStateChange.error),
                    })
                }}
            </span>
            <div
                v-for="radioValue in Object.values(RADIO_OPTIONS)"
                :key="'state_' + radioValue"
                class="device-controls__row device-controls__row--checkbox"
                :class="{
                    'device-controls__row--disabled':
                        isWaitingForResponse || changeEssModeTimer.nextChange !== null,
                }"
            >
                <div
                    class="device-controls__row device-controls__row--title"
                    @click="handleEssModeClick(radioValue)"
                >
                    <span>
                        {{
                            $t(`dashboard.dci.ess.radio.state_${radioValue}`, {
                                i18nFallback: radioValue,
                            })
                        }}
                    </span>
                    <div class="vrm-form__custom-radio-checkbox">
                        <div
                            class="sg-custom-check-and-radio custom-radio"
                            :class="{
                                'sg-disabled':
                                    isWaitingForResponse || changeEssModeTimer.nextChange !== null,
                            }"
                        >
                            <label v-if="!isMobile" title="">
                                <input type="radio" :checked="computedValue === radioValue" />
                                <div class="sg-alternative-display">
                                    <div class="sg-outer">
                                        <div class="sg-inner"></div>
                                    </div>
                                </div>
                            </label>
                            <div v-if="isMobile">
                                <radio-button-controls-mobile
                                    :checked="computedValue === radioValue"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--Since SOC is not displayed when on external control, we don't need the separator-->
            <div v-if="!isExternalControlEssSelected" class="dci__border"></div>
        </div>
        <div
            v-if="changeEssModeTimer.nextChange !== null"
            :style="{ height: bottomHeight + 'px' }"
            class="device-controls__body device-controls__body--ess"
        >
            <change-warning
                @cancel="
                    changeEssModeTimer.clearChangeTimer();
                    selectedEssMode = essMode;
                "
                @confirm="changeEssModeTimer.confirmChange()"
            >
                <div
                    v-html="
                        $t('dashboard.dci.countdown_timer', {
                            nextState: $t(
                                `dashboard.dci.ess.radio.ess_${changeEssModeTimer.nextChange}`,
                            ),
                            seconds: timerLimit - changeEssModeTimer.changeSeconds,
                        })
                    "
                ></div>
            </change-warning>
        </div>
        <div v-else ref="essBottom" class="device-controls__body device-controls__body--ess">
            <!--Do not display SOC if mode is external control-->
            <div v-if="!isExternalControlEssSelected" class="battery-slider-and-row-container">
                <span v-if="minSocChange.error" class="dci__warning dci__warning--inline">
                    {{
                        $t('dashboard.dci.errors.' + minSocChange.error, {
                            i18nFallback: dciErrorFallback(minSocChange.error),
                        })
                    }}
                </span>
                <div>
                    <div class="device-controls__row">
                        <h4
                            class="dci__subtitle"
                            :class="{
                                'dci__subtitle--disabled':
                                    isWaitingForResponse || changeModeTimer.nextChange !== null,
                            }"
                        >
                            {{
                                $t('dashboard.dci.ess_battery_soc', {
                                    i18nFallback: 'Battery SOC',
                                })
                            }}
                        </h4>
                    </div>
                    <!-- SOC slider -->
                    <div
                        class="dci__slider"
                        @click="
                            !isBatterySliderDisabled &&
                                isMobile &&
                                changeShowPopUpBattery(batteryInformationForPopUp, 'ESS-BATTERY')
                        "
                    >
                        <!-- Single slider (Dynamic ESS off); You always see the slider with 2 points if you toggle Dynamic ESS to On in the config page, same for the controls.-->
                        <div v-if="!showDynamicESSControls || !dessSocDifferent"></div>
                        <!-- Range slider (Dynamic ESS on) -->
                        <BatterySlider
                            :with-dess="showDynamicESSControls && dessSocDifferent"
                            :min-soc="minSoc"
                            :dess-soc="essSoc"
                            :active-soc="showActiveSocLimit ? Math.max(minSoc, socLimit) : null"
                            :disabled="isBatterySliderDisabled"
                            @change="onSliderChange"
                        />
                    </div>
                </div>
                <div
                    class="battery-icon-on-mobile-container"
                    @click="
                        !isBatterySliderDisabled &&
                            isMobile &&
                            changeShowPopUpBattery(batteryInformationForPopUp, 'ESS-BATTERY')
                    "
                >
                    <battery-icon-on-mobile
                        v-if="!isExternalControlEssSelected && isMobile"
                        :min-soc="minSoc"
                        :is-disabled="isBatterySliderDisabled"
                    />
                </div>
            </div>

            <div v-if="showDynamicESSControls && !onlySlider && !isExternalControlEssSelected">
                <div class="dci__border"></div>
                <!-- Dynamic ESS mode -->
                <div
                    class="device-controls__row device-controls__row--switches"
                    :class="{ 'device-controls__row--disabled': isWaitingForResponse }"
                >
                    <span class="dci__action">
                        {{
                            $t('dashboard.dci.ess_dynamic_ess', {
                                i18nFallback: 'Dynamic ESS',
                            })
                        }}
                    </span>
                    <vrm-controlled-toggle
                        v-if="!isMobile"
                        :value="selectedEssMode === DYNAMIC_ESS_OPTIONS.AUTO"
                        :disabled="isWaitingForResponse"
                        @input="changeEssModeWithTimer"
                    />
                    <vrm-new-toggle
                        v-if="isMobile"
                        :value="selectedEssMode === DYNAMIC_ESS_OPTIONS.AUTO"
                        :disabled="isWaitingForResponse"
                        @input="changeShowPopUpSwitch(isDessSwitchOn, 'SWITCH-DYNAMIC-ESS')"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import { ngInject } from '@/vue/decorators/angular-interop';
import {
    getEssSubscriptions,
    BATTERY_STATES,
    SYSTEM_VALUES,
    HUB4_OPTIONS,
    DYNAMIC_ESS_OPTIONS,
    subscribeToInfo,
    unsubscribeFromInfo,
    publishToPath,
} from './utils';
import { createTimer } from './components/Timer';
import Spinner from './components/Spinner';
import BatterySlider from './components/BatterySlider';
import { newMqttWriteValue, initiateValueLoading, resolveValue } from './writeValueUtils';
import ChangeWarning from '@/vue/components/shared/device-controls/controls/components/ChangeWarning';
import VrmControlledToggle from '@/vue/components/shared/toggles/VrmControlledToggle.vue';
import VrmNewToggle from '../../toggles/VrmNewToggle.vue';
import RadioButtonControlsMobile from './components/RadioButtonControlsMobile.vue';
import BatteryIconOnMobile from './components/BatteryIconOnMobile.vue';
import ShowPopUpControlsMobileMixin from './components/ShowPopUpControlsMobileMixin';

@Component({
    components: {
        VrmControlledToggle,
        ChangeWarning,
        Spinner,
        BatterySlider,
        VrmNewToggle,
        RadioButtonControlsMobile,
        BatteryIconOnMobile,
    },
    mixins: [ShowPopUpControlsMobileMixin],
})
@AngularLocaleBundle('dashboard')
@AngularLocaleBundle('common')
export default class Ess extends Vue {
    @ngInject()
    MQTTRealtimeService;
    @ngInject()
    $location;
    @ngInject()
    ApiService;
    @ngInject()
    $state;

    @Prop({ type: Number, required: true })
    instance;
    @Prop({ type: Number, required: true })
    installationId;
    @Prop({ type: String, required: true })
    identifier;
    @Prop({ type: Number, required: true })
    timerLimit;
    @Prop({ type: Boolean, default: false })
    hasDynamicEssCapability;
    @Prop({ type: Boolean, default: false })
    onlySlider;
    @Prop({ type: Boolean, default: false })
    dynamicEssConfigOn;
    @Prop({ type: Boolean, default: false })
    dessSocDifferent;

    //Used for mobile only
    @Prop()
    popUpData;

    SUBSCRIPTIONS = getEssSubscriptions();

    RADIO_OPTIONS = {
        OPTIMIZED_WITH_BATTERY_LIFE: 0,
        OPTIMIZED_WITHOUT_BATTERY_LIFE: 1,
        KEEP_BATTERIES: 2,
        EXTERNAL_CONTROL: 3,
    };

    DYNAMIC_ESS_OPTIONS = DYNAMIC_ESS_OPTIONS;

    // controlled by mqtt
    customName = null;
    productName = null;
    batteryLifeState = null;
    hub4Mode = null;
    minSoc = null;
    essSoc = null;
    tempEssSoc = 80;
    socLimit = null;
    selectedValue = null;

    essMode = null;
    selectedEssMode = this.DYNAMIC_ESS_OPTIONS.OFF;

    debouncedChangeMinSoc = null;
    debouncedChangeEssSoc = null;

    minSocChange = newMqttWriteValue({ varName: 'minSoc' });
    essSocChange = newMqttWriteValue({ varName: 'essSoc' });
    batteryLifeStateChange = newMqttWriteValue({ varName: 'batteryLifeState' });
    essModeChange = newMqttWriteValue({ varName: 'essMode' });

    essStateModeChange = newMqttWriteValue({ varName: 'state' });

    // inherited from createTimer at mount
    changeModeTimer = {};
    changeEssModeTimer = {};

    topHeight = 260;
    bottomHeight = 380;
    newSystemModeValue = null;

    created() {
        createTimer.call(this, 'changeModeTimer', this.timerLimit);
        createTimer.call(this, 'changeEssModeTimer', this.timerLimit);
    }

    mounted() {
        this.subscribeToInfo = subscribeToInfo.bind(this);
        this.unsubscribeFromInfo = unsubscribeFromInfo.bind(this);
        this.publishToPath = publishToPath.bind(this);
        this.initiateValueLoading = initiateValueLoading.bind(this);
        this.resolveValue = resolveValue.bind(this);
        this.subscribeToInfo();
        window.addEventListener('resize', this.handleResize);
    }

    @Watch('batteryLifeState')
    onBatteryLifeState() {
        this.resolveValue(this.batteryLifeStateChange, +this.batteryLifeState);
    }

    onSliderChange(values) {
        this.debounceChangeMinimumSoc(values[0]);
        if (values.length > 1) {
            this.debounceChangeEssSoc(values[1]);
        }
    }

    @Watch('minSoc')
    onMinSoc() {
        this.resolveValue(this.minSocChange, this.minSoc);
    }

    @Watch('essSoc')
    onEssSoc() {
        this.resolveValue(this.essSocChange, this.essSoc);
    }

    @Watch('essMode')
    onEssMode() {
        this.resolveValue(this.essModeChange, this.essMode);
        this.selectedEssMode = this.essMode;
    }

    @Watch('essStateMode')
    onEssStateMode() {
        this.resolveValue(this.essStateModeChange, this.essStateMode);
    }

    get isWaitingForResponse() {
        return (
            this.minSocChange.busy ||
            this.batteryLifeStateChange.busy ||
            this.essModeChange.busy ||
            this.essSocChange.busy
        );
    }

    beforeDestroy() {
        this.unsubscribeFromInfo();
        clearTimeout(this.debouncedChangeMinSoc);
        clearTimeout(this.debouncedChangeEssSoc);
        this.changeModeTimer.clearChangeTimer();
        this.changeEssModeTimer.clearChangeTimer();
        window.clearTimeout(this.essSocChange.timer);
        window.clearTimeout(this.batteryLifeStateChange.timer);
        window.clearTimeout(this.essModeChange.timer);
        window.removeEventListener('resize', this.handleResize);
    }

    changeSystemModeWithTimer(newValue) {
        if (this.isWaitingForResponse || this.changeEssModeTimer.nextChange !== null) return;
        this.matchBodyHeight();
        this.selectedValue = newValue;
        this.changeModeTimer.nextValue = 'state_' + newValue;
        this.changeModeTimer.callFuncWithTimer(newValue, this.changeSystemMode);
    }

    changeEssModeWithTimer(isToggledOn) {
        const newValue = isToggledOn ? DYNAMIC_ESS_OPTIONS.AUTO : DYNAMIC_ESS_OPTIONS.OFF;
        if (this.isWaitingForResponse || this.changeModeTimer.nextChange !== null) return;
        this.matchBodyHeight();
        this.selectedEssMode = newValue;
        this.changeEssModeTimer.nextValue = 'ess_' + newValue;
        this.changeEssModeTimer.callFuncWithTimer(newValue, this.changeEssMode);
    }

    changeSystemMode(newValue) {
        const {
            EXTERNAL_CONTROL,
            KEEP_BATTERIES,
            OPTIMIZED_WITH_BATTERY_LIFE,
            OPTIMIZED_WITHOUT_BATTERY_LIFE,
        } = this.RADIO_OPTIONS;

        const { BATTERY_LIFE_ACTIVE, BATTERY_SOC_GUARD_ACTIVE } = BATTERY_STATES;

        // set hub4 Mode
        if (newValue === EXTERNAL_CONTROL && this.hub4Mode !== HUB4_OPTIONS.DISABLED) {
            this.setHub4Mode(HUB4_OPTIONS.DISABLED);
        } else if (newValue !== EXTERNAL_CONTROL && this.hub4Mode === HUB4_OPTIONS.DISABLED) {
            this.setHub4Mode(HUB4_OPTIONS.PHASE_COMPENSATION);
        }

        // set battery life state
        if (newValue === OPTIMIZED_WITH_BATTERY_LIFE && this.essStateMode !== BATTERY_LIFE_ACTIVE) {
            this.setBatteryLifeState(SYSTEM_VALUES.OPTIMIZED_WITH_BATTERY_LIFE);
        } else if (
            newValue === OPTIMIZED_WITHOUT_BATTERY_LIFE &&
            this.essStateMode !== BATTERY_SOC_GUARD_ACTIVE
        ) {
            this.setBatteryLifeState(SYSTEM_VALUES.OPTIMIZED_WITHOUT_BATTERY_LIFE);
        } else if (newValue === KEEP_BATTERIES) {
            this.setBatteryLifeState(SYSTEM_VALUES.KEEP_BATTERIES);
        } else if (newValue === EXTERNAL_CONTROL) {
            this.setBatteryLifeState(SYSTEM_VALUES.DISABLED);
        }
        this.newSystemModeValue = newValue;
    }

    setBatteryLifeState(value) {
        this.batteryLifeStateChange.oldState =
            this.computedValue !== this.RADIO_OPTIONS.EXTERNAL_CONTROL
                ? this.batteryLifeState
                : SYSTEM_VALUES.DISABLED;
        this.batteryLifeStateChange.newState = +value;
        this.initiateValueLoading(this.batteryLifeStateChange);
        this.publishToPath(
            {
                dbusPath: `/Settings/CGwacs/BatteryLife/State`,
                dbusServiceType: 'settings',
                callbackIdentifier: `setBatteryLifeState_${this.instance}`,
            },
            { value },
            this.computedValue !== this.RADIO_OPTIONS.EXTERNAL_CONTROL
                ? this.batteryLifeState
                : SYSTEM_VALUES.DISABLED,
        );
    }

    setHub4Mode(value) {
        this.publishToPath(
            {
                dbusPath: `/Settings/CGwacs/Hub4Mode`,
                dbusServiceType: 'settings',
                callbackIdentifier: `setHub4Mode_${this.instance}`,
            },
            { value },
            this.hub4Mode,
        );
    }

    changeEssMode(value) {
        this.essModeChange.newState = +value;
        this.initiateValueLoading(this.essModeChange);
        this.publishToPath(
            {
                dbusPath: `/Settings/DynamicEss/Mode`,
                dbusServiceType: 'settings',
                callbackIdentifier: `setEssMode_${this.instance}`,
            },
            { value },
            this.essMode,
        );
        if (+value !== this.DYNAMIC_ESS_OPTIONS.AUTO) return;
        // Request schedule because we just enabled DESS
        this.ApiService.scheduleDynamicEss(this.installationId);
    }

    changeMinimumSoc(value) {
        if (this.isWaitingForResponse || value === this.minSoc) return;

        this.minSocChange.oldState = this.minSoc;
        this.minSocChange.newState = +value;
        this.initiateValueLoading(this.minSocChange);

        this.publishToPath(
            {
                dbusPath: `/Settings/CGwacs/BatteryLife/MinimumSocLimit`,
                dbusServiceType: 'settings',
                callbackIdentifier: `setMinimumSocLimit_${this.instance}`,
            },
            { value },
            this.minSoc,
        );
    }

    changeEssSoc(value) {
        if (this.isWaitingForResponse || value === this.essSoc) return;

        this.essSocChange.oldState = this.essSoc;
        this.essSocChange.newState = +value;
        this.initiateValueLoading(this.essSocChange);
        this.publishToPath(
            {
                dbusPath: `/Settings/DynamicEss/MinSoc`,
                dbusServiceType: 'settings',
                callbackIdentifier: `setEssSoc_${this.instance}`,
            },
            { value },
            this.essSoc,
        );
    }

    debounceChangeMinimumSoc(event) {
        clearTimeout(this.debouncedChangeMinSoc);
        this.debouncedChangeMinSoc = setTimeout(() => {
            this.changeMinimumSoc(event);
        }, 500);
    }

    debounceChangeEssSoc(event) {
        clearTimeout(this.debounceChangeEssSocEvent);
        this.debounceChangeEssSocEvent = setTimeout(() => {
            this.changeEssSoc(event);
        }, 500);
    }

    getCallbackIdentifier(varName) {
        return `get_${varName}OfESS_${this.instance}`;
    }

    goToSettings(event) {
        if (event.target.id === 'settings/ess') {
            this.$state.go('base.installation.settings.dynamicEss', {
                id: this.idSite,
            });
        }
        document.body.style.overflow = 'auto';
    }

    get idSite() {
        return this.$route.params.id;
    }

    get isExternalControlEssSelected() {
        return this.computedValue === this.RADIO_OPTIONS.EXTERNAL_CONTROL;
    }

    get essStateMode() {
        // optimized mode with battery life
        if (this.batteryLifeState >= 1 && this.batteryLifeState <= 8) {
            return BATTERY_STATES.BATTERY_LIFE_ACTIVE;
        }
        // keep bateries charged
        if (this.batteryLifeState === 9) {
            return BATTERY_STATES.BATTERY_KEEP_CHARGED;
        }
        // optimized mode without battery life
        if (this.batteryLifeState >= 10 && this.batteryLifeState <= 12) {
            return BATTERY_STATES.BATTERY_SOC_GUARD_ACTIVE;
        }
        // should not happen
        return null;
    }

    get computedValue() {
        const {
            BATTERY_LIFE_ACTIVE,
            BATTERY_SOC_GUARD_ACTIVE,
            BATTERY_KEEP_CHARGED,
        } = BATTERY_STATES;
        const {
            EXTERNAL_CONTROL,
            KEEP_BATTERIES,
            OPTIMIZED_WITH_BATTERY_LIFE,
            OPTIMIZED_WITHOUT_BATTERY_LIFE,
        } = this.RADIO_OPTIONS;

        if (this.hub4Mode === HUB4_OPTIONS.DISABLED) {
            return EXTERNAL_CONTROL;
        }
        if (this.essStateMode === BATTERY_LIFE_ACTIVE) {
            return OPTIMIZED_WITH_BATTERY_LIFE;
        }
        if (this.essStateMode === BATTERY_SOC_GUARD_ACTIVE) {
            return OPTIMIZED_WITHOUT_BATTERY_LIFE;
        }
        if (this.essStateMode === BATTERY_KEEP_CHARGED) {
            return KEEP_BATTERIES;
        }
        return EXTERNAL_CONTROL;
    }

    get formattedName() {
        if (this.customName) {
            return this.customName;
        }
        if (this.productName) {
            return this.productName;
        }
        return `ESS`;
    }

    get isMinSocDisabled() {
        return (
            this.hub4Mode === HUB4_OPTIONS.DISABLED ||
            this.essStateMode === BATTERY_STATES.BATTERY_KEEP_CHARGED
        );
    }

    get showActiveSocLimit() {
        return (
            this.hub4Mode !== HUB4_OPTIONS.DISABLED &&
            this.essStateMode === BATTERY_STATES.BATTERY_LIFE_ACTIVE &&
            this.minSoc &&
            this.socLimit
        );
    }

    get showDynamicESSControls() {
        const { OPTIMIZED_WITH_BATTERY_LIFE, OPTIMIZED_WITHOUT_BATTERY_LIFE } = this.RADIO_OPTIONS;

        return (
            // Dynamic ESS is available in Venus OS
            this.hasDynamicEssCapability &&
            // Config toggle from Dynamic ESS settings
            (this.dynamicEssConfigOn ||
                // or DESS is in External mode
                this.isExternalDessEnabled) &&
            // ESS is Optimized with Battery Life or Optimized without Battery Life
            (this.computedValue === OPTIMIZED_WITH_BATTERY_LIFE ||
                this.computedValue === OPTIMIZED_WITHOUT_BATTERY_LIFE)
        );
    }

    get isAutoEssEnabled() {
        return this.essMode === this.DYNAMIC_ESS_OPTIONS.AUTO;
    }

    get isExternalDessEnabled() {
        return this.essMode === this.DYNAMIC_ESS_OPTIONS.EXTERNAL;
    }

    get mqttPathObj() {
        return {
            identifier: this.identifier,
            dbusServiceType: 'hub4',
            instance: this.instance,
        };
    }

    get locationSearch() {
        return this.$location.search();
    }

    // locationSearch is not reactive so these getters will return the first observed value
    get essAction() {
        return this.locationSearch.essAction;
    }

    get essValue() {
        return this.locationSearch.essValue;
    }

    get bundleForQueryCommands() {
        return {
            location: this.$location,
            hub4Mode: this.hub4Mode,
            essStateMode: this.essStateMode,
            essMode: this.essMode,
        };
    }

    @Watch('bundleForQueryCommands', { immediate: true })
    onQueryChange() {
        if (this.hub4Mode === null) {
            return;
        }
        this.$nextTick(() => {
            const essAction = this.$location.search().essAction;
            const essValue = this.$location.search().essValue;
            if (essAction === undefined) {
                return;
            }

            if (essAction === 'setEssValue') {
                if (essValue === undefined) {
                    return;
                }
                this.changeSystemModeWithTimer(+essValue);
            }

            this.$location.search('essAction', null);
            this.$location.search('essValue', null);
            this.$location.search('mobileOpenControls', null);
        });
    }

    matchBodyHeight() {
        if (this.$refs.essTop !== undefined) this.topHeight = this.$refs.essTop.clientHeight;
        if (this.$refs.essBottom !== undefined)
            this.bottomHeight = this.$refs.essBottom.clientHeight;
    }

    dciErrorFallback(error) {
        switch (error) {
            case 'could_not_reach_installation':
                return 'Having trouble communicating';
            case 'something_went_wrong':
                return 'Something went wrong';
            case 'write_value_adjusted':
                return 'Value set to closest acceptable value';
        }
    }

    convertOptionNameToValue(name) {
        switch (name) {
            case this.$t('dashboard.dci.ess.radio.state_0'):
                return 0;
            case this.$t('dashboard.dci.ess.radio.state_1'):
                return 1;
            case this.$t('dashboard.dci.ess.radio.state_2'):
                return 2;
            case this.$t('dashboard.dci.ess.radio.state_3'):
                return 3;
            default:
                return null;
        }
    }

    get isBatterySliderDisabled() {
        return (
            this.isWaitingForResponse ||
            this.changeModeTimer.nextChange !== null ||
            this.isMinSocDisabled
        );
    }

    get isPopUpTypeESS() {
        return (
            this.popUpData.popUpType === 'ESS' ||
            this.popUpData.popUpType === 'ESS-BATTERY' ||
            this.popUpData.popUpType === 'SWITCH-DYNAMIC-ESS'
        );
    }

    get changeSystemModeViaPopUp() {
        return (
            this.confirmedChoiceViaPopUp.confirmedRadioButton !== undefined &&
            this.confirmedChoiceViaPopUp.confirmedPopUpType === 'ESS' &&
            this.convertOptionNameToValue(this.confirmedChoiceViaPopUp.confirmedRadioButton) !==
                this.computedValue
        );
    }

    get changeMinimumSocViaPopUp() {
        return (
            this.confirmedChoiceViaPopUp.confirmedBatterySlider !== undefined &&
            this.confirmedChoiceViaPopUp.confirmedPopUpType === 'ESS-battery'
        );
    }

    get changeEssModeViaPopUp() {
        return (
            this.confirmedChoiceViaPopUp.confirmedIsOn !== undefined &&
            this.confirmedChoiceViaPopUp.confirmedPopUpType === 'SWITCH-DYNAMIC-ESS' &&
            this.confirmedChoiceViaPopUp.confirmedIsOn === Boolean(this.essMode)
        );
    }

    get isDessSwitchOn() {
        return this.selectedEssMode === this.DYNAMIC_ESS_OPTIONS.AUTO;
    }

    get batteryInformationForPopUp() {
        return {
            minSoc: this.minSoc,
            essSoc: this.essSoc,
            showActiveSocLimit: this.showActiveSocLimit,
            socLimit: this.socLimit,
        };
    }

    getRadioNameFromValue(value) {
        // Find the key (name) corresponding to the given value
        const key = Object.keys(this.RADIO_OPTIONS).find(k => this.RADIO_OPTIONS[k] === value);
        //Formatting the string by removing  underscores and making it lower case
        return key.replace(/_/g, ' ').toLowerCase();
    }

    handleEssModeClick(radioValue) {
        const isSameValue = this.computedValue === radioValue;
        const isChangeBlocked =
            this.isWaitingForResponse || this.changeEssModeTimer.nextChange !== null;

        if (this.isMobile) {
            if (!isSameValue && !this.isWaitingForResponse) {
                const translatedName = this.$t(`dashboard.dci.ess.radio.state_${radioValue}`);
                this.changeShowPopUpMode(translatedName, 'ESS');
            }
        } else {
            if (!isSameValue && !isChangeBlocked) {
                this.changeSystemModeWithTimer(radioValue);
            }
        }
    }
}
</script>
